import React from 'react';

import Presenter from 'components/presenters/challenge/ChallengeReward';

export default function ChallengeReward({rewards }) {  
	return (
		<Presenter rewards={rewards} /> 
	);
}

